import React from "react";
import "./AirportService.css"; // Ajoutez un fichier CSS pour styliser la section
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneDeparture, faClock, faChild } from "@fortawesome/free-solid-svg-icons";


const AirportService = () => {
  const services = [
    {
     /* icon: "🧳", // Vous pouvez utiliser un emoji ou une icône SVG ici */
      icon: <FontAwesomeIcon icon={faPlaneDeparture} />,
      title: "Executive Airport Transfers",
      description:
        "Experience top-tier comfort and punctuality with our executive transfers from any Paris airport.",
    },
    {
        icon: <FontAwesomeIcon icon={faChild} />,
      title: "Family-Friendly Shuttle Service",
      description:
        "Enjoy stress-free travel for the whole family, with spacious vehicles and child-friendly amenities.",
    },
    {
        icon: <FontAwesomeIcon icon={faClock} />,
      title: "24/7 Airport Pick-up Service",
      description:
        "Reliable round-the-clock pick-up services ensuring you’re never stranded at the airport, day or night.",
    },
  ];

  return (
    <section id="airport-service" className="py-5">
      <div className="container-fluid">
        <div className="row text-center">
          {services.map((service, index) => (
            <div className="col-md-4" key={index}>
              <div className="service-item">
                <div className="service-icon">{service.icon}</div>
                <h2 className="service-title">{service.title}</h2>
                <p className="service-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AirportService;
